import {
  GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER,
  OPTIMIZELY_VARIANT_KEYS,
} from '../../../constants'
import { useSpecificOptimizelyUserDecision } from '../optimizely-for-client'

export function useTrustpilotUspsBannerVisible(): boolean {
  const decisionObj = useSpecificOptimizelyUserDecision(
    GUEST_ENGAGEMENT_TRUSTPILOT_USPS_BANNER,
    true,
  )

  const decision =
    decisionObj?.variationKey ===
    OPTIMIZELY_VARIANT_KEYS.TRUSTPILOT_USPS_VISIBLE

  return decision
}
